<template>
	<div>
		<el-col :span="8">
			<el-card class="goods-paybox goods-item">
				<div class="subact-box">
					<button class="subact-btn" type="button" @click="openBookBox">
						<i class="el-icon-notebook-2"></i>
						<span>加入书单</span>
					</button>

					<button class="subact-btn" type="button" @click="handleVisit" v-if="shouldShowVisitUrl">
						<i class="el-icon-reading"></i>
						<span>官方链接</span>
					</button>
					<button class="subact-btn" type="button" v-click-once @click="download" v-if="digitStandardProduct.some(item => item.hadBuy)">
						<i class="el-icon-download"></i>
						<span>下载电子版</span>
					</button>
					<!-- v-if="info.isPdf" -->
					<button class="subact-btn" type="button" v-click-once @click="openPDF(info.pdfRead)" v-if="info.isPdf == 1 && info.defaultPdf !== null">
						<!-- 不能选中的class= subact-btn-nor -->
						<el-tag size="small" class="tag-type"> {{ info.pdfRead == 0 ? '公开' : info.pdfRead == 1 ? 'VIP阅读' : info.pdfRead == 2 ? '购买阅读' : '' }}</el-tag>
						<i class="el-icon-view"></i>
						<span>PDF阅读</span>
					</button>
					<!-- v-if="info.isJson" -->
					<button class="subact-btn" type="button" v-click-once @click="openDoc(info.jsonRead)" v-if="info.isJson !== 0">
						<el-tag size="small" class="tag-type"> {{ info.jsonRead == 0 ? '公开' : info.jsonRead == 1 ? 'VIP阅读' : info.jsonRead == 2 ? '购买阅读' : '' }}</el-tag>
						<i class="el-icon-view"></i>
						<span>智能文档阅读</span>
					</button>
				</div>
			</el-card>
			<el-card class="goods-paybox goods-item">
				<div class="goods-address-box msg-box">
					<h4>正版图书购买</h4>
				</div>

				<div class="product-list-box">
					<!-- 纸质版 -->
					<div v-if="paperStandardProduct.length" class="product-group">
						<!-- <label class="group-label">纸质版</label> -->
						<div v-for="(item, index) in paperStandardProduct" :key="'paper_' + index" class="product-item" :class="{ selected: item.checked }" @click.stop.prevent="togglePaperSelection(item, index)">
							<el-checkbox v-model="item.checked" class="item-check"></el-checkbox>
							<div class="product-info">
								<div class="product-name">
									<el-tag size="mini" type="primary" effect="plain" class="product-type-tag">纸质版</el-tag>
								</div>
								<div class="product-spu" v-if="item.prdSpuName" :title="item.prdSpuName">{{ formatProductName(item) }}</div>
								<div class="product-price">
									<span class="now-price">￥{{ getDisplayPrice(item) }}</span>
									<span class="before-price" v-if="item.defaultPrice && getDisplayPrice(item) < item.defaultPrice">￥{{ item.defaultPrice }}</span>
									<el-tag v-if="calculateDiscount(item) !== null" size="mini" type="danger" class="discount-tag">{{ (calculateDiscount(item) * 10).toFixed(1) }}折</el-tag>
									<span class="vip-price" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">VIP ￥{{ item.vipPrice }}</span>
								</div>
								<!-- <div v-if="!uisLogin" class="now-price mask-price">**元</div> -->
								<div class="quantity-control" @click.stop>
									<el-input-number v-model="item.curBuyNum" :min="1" size="mini"></el-input-number>
								</div>
								<el-button v-if="item.standardId && item.standardId != info.id" class="main-file" type="text" size="mini" @click.stop="handleMain(item)">查看主文件 →</el-button>
							</div>
						</div>
					</div>

					<!-- 电子版 -->
					<div v-if="digitStandardProduct.length" class="product-group">
						<div
							v-for="(item, index) in digitStandardProduct"
							:key="'digit_' + index"
							class="product-item"
							:class="{ selected: item.checked, purchased: item.hadBuy }"
							@click.stop.prevent="toggleDigitalSelection(item, index)"
						>
							<el-checkbox v-model="item.checked" class="item-check"></el-checkbox>
							<div class="product-info">
								<div class="product-name">
									<el-tag size="mini" :type="item.hadBuy ? 'success' : 'warning'" effect="plain" class="product-type-tag">电子版{{ item.hadBuy ? ' · 已购' : '' }}</el-tag>
								</div>
								<div class="product-spu" v-if="item.prdSpuName" :title="item.prdSpuName">{{ formatProductName(item) }}</div>
								<div class="product-price">
									<span class="now-price">￥{{ getDisplayPrice(item) }}</span>
									<span class="before-price" v-if="item.defaultPrice && getDisplayPrice(item) < item.defaultPrice">￥{{ item.defaultPrice }}</span>
									<el-tag v-if="calculateDiscount(item) !== null" size="mini" type="danger" class="discount-tag">{{ (calculateDiscount(item) * 10).toFixed(1) }}折</el-tag>
									<span class="vip-price" v-if="!isVipUser && item.vipPrice && item.vipPrice < item.curPrice">VIP ￥{{ item.vipPrice }}</span>
								</div>
								<el-button v-if="item.standardId && item.standardId != info.id" class="main-file" type="text" size="mini" @click.stop="handleMain(item)">查看主文件 →</el-button>
							</div>
						</div>
					</div>

					<!-- <li v-if="jsonStandardProduct.length">
							<label class="cart-label">结构化版</label>
							<div class="tag-list">
								<div v-for="(item, index) in jsonStandardProduct" :key="index" :class="{ selected: item.checked }" class="tag-item" @click.stop.prevent="toggleJsonSelection(item, index)">
									<el-checkbox v-model="item.checked"></el-checkbox>
									<div style="margin-left: 18px; flex: 1">
										<h6>{{ item.prdSpuName }}</h6>
										<div class="flexBetween">
												<div>
													<em class="now-price"> {{ getDisplayPrice(item) }}元</em>
													<em class="before-price"> {{ item.defaultPrice }}元</em>
													<el-tag v-if="calculateDiscount(item) !== null" size="mini" style="margin-left: 12px" type="danger">{{ calculateDiscount(item) * 10 }}折</el-tag>
												</div>
											</div>
											<div v-if="!isVipUser">
												<em class="vip-price"> VIP会员价格：{{ item.vipPrice }}元</em>
											</div>
											<el-button v-if="item.standardId && item.standardId != info.standardId" class="main-file" type="primary" size="mini" @click="handleMain(item)">查看主文件</el-button>
									</div>
								</div>
							</div>
					</li> -->
				</div>

				<div class="act-box" v-if="paperStandardProduct.length > 0 || digitStandardProduct.length > 0 || jsonStandardProduct.length > 0">
					<button class="btn btn-add" type="button" v-click-once="2000" @click="onAddToCart($event)" v-if="uisLogin">
						<i class="el-icon-shopping-cart-2"></i>
						<span>加入购物车</span>
					</button>
					<el-button style="width: 100%; line-height: 13px" v-else type="danger" plain round @click="handleLogin">请先登录后购买</el-button>
					<!-- <el-link type="danger" style="margin-left: 50%; transform: translate(-50%, 0); font-size: 16px" :underline="false" v-else @click="handleLogin">请先登录后购买</el-link> -->
				</div>

				<div class="vip-box msg-box" v-if="paperStandardProduct.length > 0 || digitStandardProduct.length > 0 || jsonStandardProduct.length > 0">
					<h4>购买说明</h4>
					<ul>
						<li>出版社官方授权正版图书，可用于企业资质评审，在线验真</li>
						<li>电子版购买后可下载PDF格式文件，永久在线阅读</li>
						<li>“特规通”平台所销售正版图书/标准均由<strong>北京品读文化发展有限公司</strong>提供，由品读文化开具图书发票</li>
						<li>
							标准文本（电子版、纸质版）属于具有唯一性、时效性、版权保护需求的特殊商品。一经售出，不接受任何理由的退货或换货。如遇质量问题，请与在线客服或客服电话联系（详见<el-link
								type="primary"
								:underline="false"
								@click="openBookSalesAgreement"
								class="agreement-link"
								>图书销售协议</el-link
							>）
						</li>
					</ul>
				</div>

				<div class="vip-box msg-box" v-if="paperStandardProduct.length == 0 && digitStandardProduct.length == 0 && jsonStandardProduct.length == 0">
					<div class="empty-box">
						<p>暂无购买资源，如需要请与销售人员联系</p>
						<p>联系电话：18911620150</p>
					</div>
				</div>
			</el-card>

			<BookBox ref="BookBoxRef" :standardId="info.id" @confirm="handleBookConfirm"></BookBox>

			<DialogWatermark ref="dialogWatermark" @confirmInfo="handleWatermarkConfirm"></DialogWatermark>
		</el-col>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import BookBox from '@/components/Book/BookBox.vue';
	import TMessage from '@/utils/TMessage';
	import TMessageBox from '@/utils/TMessageBox';
	import User from '@/utils/User';
	import TLoading from '@/utils/TLoading';
	import DialogWatermark from '@/views/StandardsView/components/DialogWatermark.vue';

	import { getDownloadCheck, getReadCheck } from '@/api/standards/doc';
	import { getConsumerOrderQueryStandard } from '@/api/order/order';
	import { getMemberGetBookList } from '@/api/book/type';
	import { postMemberAddBookToList } from '@/api/book/book';
	import { postAddCorporateCatalog } from '@/api/book/corporateCatalog.js';
	import { getPersonalBookList } from '@/api/book/personalBook.js';
	// import { visibility } from 'html2canvas/dist/types/css/property-descriptors/visibility';

	export default {
		props: {
			info: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				// 纸质版产品
				paperStandardProduct: [],
				// 电子版产品
				digitStandardProduct: [],
				// 结构化版产品
				jsonStandardProduct: [],
				//loading 实例
				loadingInstance: null
			};
		},
		computed: {
			...mapGetters('Cart', ['cartNum', 'isHasGoods']),
			...mapGetters('User', ['uisLogin']),

			// 获取用户信息
			...mapGetters('User', ['uinfo']),

			// 判断是否为有效VIP用户（未登录返回false，已登录需levelId非0且levelEnd未过期）
			isVipUser() {
				if (!this.uisLogin || !this.uinfo) return false;
				const hasValidLevelId = this.uinfo.levelId && this.uinfo.levelId !== 0;
				const now = new Date().getTime();
				const levelEndValid = this.uinfo.levelEnd && new Date(this.uinfo.levelEnd).getTime() > now;
				return hasValidLevelId && levelEndValid;
			},

			// 判断是否显示官方链接
			shouldShowVisitUrl() {
				if (!this.uisLogin) return false;
				// 非特种设备库：全部显示官方链接
				if (!this.info.standardIndustry || (this.info.standardIndustry.length === 0 && this.info.visitUrl)) {
					return this.info.visitUrl;
				}
				// 特种设备库：只有不提供任何形式的阅读时才显示
				if (this.info.isPdf == 0 && this.info.isJson == 0 && this.info.visitUrl) {
					return this.info.visitUrl;
				}
			}
		},

		watch: {
			'info.paperStandardProduct': {
				handler(val, oldVal) {
					this.paperStandardProduct = val.map(item => {
						return {
							...item
						};
					});
					// console.log('paperStandardProduct', this.paperStandardProduct);
				},
				deep: true
			},
			'info.digitStandardProduct': {
				handler(val, oldVal) {
					this.digitStandardProduct = val;
				},
				deep: true
			},
			'info.jsonStandardProduct': {
				handler(val, oldVal) {
					this.jsonStandardProduct = val;
				},
				deep: true
			}
		},

		methods: {
			handleLogin() {
				this.setLoginShow(true);
				// const targetRoute = this.$router.resolve({
				// 	path: '/login'
				// });
				// window.open(targetRoute.href, '_blank');
			},

			handleVisit() {
				window.open(this.info.visitUrl, '_blank');
			},

			handleMain(item) {
				const { standardId, standardName, standardCode } = item;
				const targetRoute = this.$router.resolve({
					path: '/StandardsDet',
					query: { id: standardId }
				});
				window.open(targetRoute.href, '_blank');
			},

			// 格式化产品名称：避免重复拼接标准号
			// 1. 如果 prdSpuName 已包含 standardCode（原样），不拼接
			// 2. 如果包含'合订本'，不拼接
			// 3. 如果 prdSpuName 开头是 standardCode 去掉空格的版本（如 GB/T36668.5-2020游乐设施...），也不拼接
			formatProductName(item) {
				if (!item.prdSpuName) return item.prdSpuName;
				const standardCode = this.info.standardCode;
				
				// 包含'合订本'不拼接
				if (item.prdSpuName.indexOf('合订本') !== -1) {
					return item.prdSpuName;
				}
				
				// 已包含标准号（原样）不拼接
				if (standardCode && item.prdSpuName.indexOf(standardCode) !== -1) {
					return item.prdSpuName;
				}
				
				// 标准号去空格后在名称开头，也不拼接
				// 例：prdSpuName="GB/T36668.5-2020游乐设施..." standardCode="GB/T 36668.5-2020"
				if (standardCode) {
					const codeWithoutSpace = standardCode.replace(/\s+/g, '');
					const nameStart = item.prdSpuName.substring(0, codeWithoutSpace.length).replace(/\s+/g, '');
					if (nameStart === codeWithoutSpace) {
						return item.prdSpuName;
					}
				}
				
				return standardCode ? standardCode + ' ' + item.prdSpuName : item.prdSpuName;
			},

			// 获取显示价格（会员用户显示vipPrice，非会员显示curPrice）
			getDisplayPrice(item) {
				const displayPrice = this.isVipUser ? item.vipPrice : item.curPrice;
				// console.log(`用户类型: ${this.isVipUser ? '会员用户' : '普通用户'}, 显示价格: ${displayPrice}, 会员价: ${item.vipPrice}, 普通价: ${item.curPrice}`);
				return displayPrice;
			},

			// 计算折扣率
			calculateDiscount(item) {
				const displayPrice = this.getDisplayPrice(item);
				const originalPrice = item.defaultPrice;

				// console.log(`显示价格: ${displayPrice}, 原价: ${originalPrice}`);

				// 检查价格是否有效
				if (!displayPrice || !originalPrice || originalPrice <= 0) {
					return null;
				}

				// 如果价格相同或显示价格大于原价，不显示折扣
				if (displayPrice >= originalPrice) {
					return null;
				}

				// 计算折扣率（保留2位小数）
				const discountRate = displayPrice / originalPrice;
				const roundedDiscount = parseFloat(discountRate.toFixed(2));

				// 如果折扣率大于等于1（即没有折扣），不显示
				if (roundedDiscount >= 1) {
					return null;
				}
				// console.log(`折扣率1111: ${roundedDiscount}`);
				return roundedDiscount.toFixed(2);
			},

			// 切换纸质版选择状态
			togglePaperSelection(curItem, index) {
				//如果剩余数量是0，则不能选择
				// if (curItem.stockNum === 0) {
				// 	TMessage.warning('该商品已售罄！');
				// 	return;
				// }
				const newItem = { ...curItem, checked: !curItem.checked };
				this.$set(this.paperStandardProduct, index, newItem);
			},

			// 切换电子版选择状态
			toggleDigitalSelection(item, index) {
				item.checked = !item.checked;
				this.$set(this.digitStandardProduct, index, item);
			},

			// 切换结构化版选择状态
			toggleJsonSelection(item, index) {
				item.checked = !item.checked;
				this.$set(this.jsonStandardProduct, index, item);
			},

			// 打开PDF
			openPDF(docPdfRead) {
				console.log('openPDF', docPdfRead);
				if (this.uisLogin) {
					//如果文件是“VIP阅读”，用户不是VIP的话，弹框显示“请升级VIP或购买此文件”
					getReadCheck(this.info.id).then(res => {
						if (res.code === 200) {
							let pdfRead = res.data.pdfRead;
							if (pdfRead) {
								const targetRoute = this.$router.resolve({
									path: '/StandardsPdf',
									query: { id: this.info.id, code: this.info.standardCode, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.id }
								});
								window.open(targetRoute.href, '_blank');
								// this.$router.push({ path: '/index/StandardsPdf', query: { id: this.info.id, title: this.info.standardName, fileName: this.info.defaultPdf, docId: this.info.id } });
							} else {
								// 如果文件不是“VIP阅读”，用户不是VIP的话，弹框显示“请购买此文件”
								if (docPdfRead == 1) {
									if (this.info.defaultPdf) {
										TMessage.warning('VIP文档，请升级后阅读，或购买后阅读！');
									} else {
										TMessage.warning('未找到PDF文件！');
									}
								}
								if (docPdfRead == 2) {
									if (this.info.defaultPdf) {
										TMessage.warning('请购买后阅读！');
									} else {
										TMessage.warning('未找到PDF文件！');
									}
								}

								// if (this.info.defaultPdf) {
								// 	TMessage.warning('请您购买后阅读文件！');
								// } else {
								// 	TMessage.warning('未找到PDF文件！');
								// }
								// else {
								// 	TMessage.warning(res.msg || '未找到PDF文件！');
								// }
							}
						} else {
							TMessage.error('未找到PDF文件！');
						}
					});
				} else {
					console.log('openPDF-login', docPdfRead);
					this.setLoginShow(true);
					// const targetRoute = this.$router.resolve({
					// 	path: '/login'
					// });
					// window.open(targetRoute.href, '_blank');
				}
			},

			// 下载文件
			async download() {
				if (this.uisLogin) {
					this.loadingInstance = TLoading.startBgWhite({ text: '文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
					try {
						const response = await fetch(`/webL_api/consumer/order/downloadCorporateBook/${this.info.id}`, {
							method: 'get',
							headers: {
								Authorization: 'Bearer ' + User.getToken(),
								'corporate-id': User.getCorporate().corporateId,
								'Content-Type': 'application/json'
							}
						});

						if (!response.ok) {
							throw new Error(`HTTP error! status: ${response.status}`);
						}

						console.log('response:', response);

						const arrayBuffer = await response.arrayBuffer();
						const blob = new Blob([arrayBuffer], { type: 'zip' });

						// 创建下载链接而不是打开文件
						this.downloadFile(blob, this.info.standardName + '.zip');
					} catch (error) {
						TLoading.close(this.loadingInstance);
						console.error('下载文件失败:', error);
						this.$message.error('文件下载失败，请重试！');
					}
				} else {
					this.setLoginShow(true);
					// const targetRoute = this.$router.resolve({
					// 	path: '/login'
					// });
					// window.open(targetRoute.href, '_blank');
				}
			},

			// 通用文件下载方法
			downloadFile(blob, filename) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				// 显示下载成功提示
				this.$message.success('文件下载成功！');
				TLoading.close(this.loadingInstance);
			},

			// 已购电子版 - 下载
			handleDownloadItem(item) {
				getDownloadCheck(this.info.id).then(res => {
					if (res.data === null) {
						TMessage.warning('暂无可下载文件');
					} else {
						const targetRoute = this.$router.resolve({
							path: '/UserCenter/BookOrder',
							query: { orderNum: res.data }
						});
						window.open(targetRoute.href, '_blank');
					}
				});
			},

			// 已购电子版 - 阅读
			handleReadItem(item) {
				getConsumerOrderQueryStandard(item.prdSkuId).then(res => {
					if (res.code == 200) {
						const info = res.data;
						if (info.defaultPdf) {
							const targetRoute = this.$router.resolve({
								path: '/StandardsPdf',
								query: { id: info.standardId, code: info.standardCode, title: info.standardName, fileName: info.defaultPdf, docId: info.standardId }
							});
							window.open(targetRoute.href, '_blank');
						} else if (info.defaultJson) {
							this.$router.push({ path: '/StandardsDoc', query: { docId: info.standardId } });
						} else {
							TMessage.warning('未找到可阅读文件');
						}
					}
				});
			},

			//下载文件
			async handleWatermarkConfirm(form) {
				this.loadingInstance = TLoading.startBgWhite({ text: '文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
				let params = {
					standardId: this.info.id,
					watermark: form.watermark,
					iwater: form.waterType
				};
				const response = await fetch(`/webL_api/consumer/order/downloadBook`, {
					method: 'post',
					body: JSON.stringify(params),
					headers: {
						Authorization: 'Bearer ' + User.getToken(),
						'Content-Type': 'application/json'
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				if (response) {
					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
					TLoading.close(this.loadingInstance);
					window.open(URL.createObjectURL(blob));
				}
			},

			// 打开结构化阅读
			openDoc(docJsonRead) {
				if (this.uisLogin) {
					getReadCheck(this.info.id).then(res => {
						if (res.code === 200) {
							let jsonRead = res.data.jsonRead;
							if (jsonRead) {
								// const targetRoute = this.$router.resolve({
								// 	path: '/index/StandardsDoc',
								// 	query: { id: this.info.id, code: this.info.standardCode, title: this.info.standardName, docId: this.info.id }
								// });
								// window.open(targetRoute.href, '_blank');
								this.$router.push({ path: '/StandardsDoc', query: { id: this.info.id, code: this.info.standardCode, title: this.info.standardName, docId: this.info.id } });
							} else {
								// if (this.info.defaultJson) {
								// 	TMessage.warning('请您购买后阅读文件！');
								// } else {
								// 	TMessage.warning('未找到智能文档文件！');
								// }

								if (docJsonRead == 1) {
									TMessage.warning('VIP文档，请升级后阅读，或购买后阅读！');
								}
								if (docJsonRead == 2) {
									TMessage.warning('请购买后阅读！');
								}
							}
						} else {
							TMessage.error('未找到智能文档文件！');
						}
					});
				} else {
					this.setLoginShow(true);
					// const targetRoute = this.$router.resolve({
					// 	path: '/login'
					// });
					// window.open(targetRoute.href, '_blank');
				}
			},

			// 打开图书销售协议
			openBookSalesAgreement() {
				const targetRoute = this.$router.resolve({
					path: '/info',
					query: {
						group: '关于我们',
						id: 3,
						type: 'content',
						title: '图书销售协议'
					}
				});
				window.open(targetRoute.href, '_blank');
			},

			// 加入书单
			openBookBox() {
				if (this.uisLogin) {
					//查询有无书单
					getPersonalBookList({ catalogType: 2 }, 1, 15).then(res => {
						if (res.code === 200) {
							let bookList = res.data.rows;
							if (bookList.length > 0) {
								this.$refs.BookBoxRef.visible = true;
							} else {
								TMessageBox.confirm('您还没有添加书单，是否去添加？', '提示', { confirmButtonText: '去添加' }).then(() => {
									//开新tab
									const targetRoute = this.$router.resolve({
										path: '/BookCenter/BuyList'
									});
									window.open(targetRoute.href, '_blank');
									// this.$router.push({ path: '/index/BookCenter/BookList' });
								});
							}
						} else {
							TMessage.error('未找到书单！');
						}
					});
				} else {
					this.setLoginShow(true);
					// const targetRoute = this.$router.resolve({
					// 	path: '/login'
					// });
					// window.open(targetRoute.href, '_blank');
				}
			},

			handleBookConfirm(id) {
				postAddCorporateCatalog({
					documentId: [this.info.id],
					catalogId: id
				}).then(res => {
					if (res.code === 200) {
						this.$refs.BookBoxRef.visible = false;
						TMessage.success('加入书单成功！');
					} else {
						TMessage.error(res.msg || '加入书单失败！');
					}
				});

				return;

				postMemberAddBookToList({
					listId: bookId,
					bookId: this.info.id
				}).then(res => {
					if (res.code === 200) {
						this.$refs.BookBoxRef.visible = false;
						if (res.data) {
							TMessage.success('加入书单成功！');
						} else {
							TMessage.warning('该书单已存在！');
						}
					} else {
						TMessage.error('加入书单失败！');
					}
				});
			},

			// 登录后执行
			onLoginSuccess() {
				switch (this.nextAct) {
					case 'onAddToCart':
						this.onAddToCart();
						break;
					case 'openBookBox':
						this.openBookBox();
						break;
					case 'openPDF':
						this.openPDF();
						break;
					case 'openDoc':
						this.openDoc();
						break;
					case 'download':
						this.download();
						break;
					case 'onBuy':
						this.onBuy();
						break;
				}
				this.nextAct = '';
			},

			// 加入购物车
			onAddToCart(event) {
				if (this.uisLogin) {
					this.addToCart(event);
				} else {
					this.setLoginShow(true);
					// const targetRoute = this.$router.resolve({
					// 	path: '/login'
					// });
					// window.open(targetRoute.href, '_blank');
				}
			},

			// 购买
			async addToCart(event) {
				let list = [];
				if (this.paperStandardProduct.length > 0) {
					this.paperStandardProduct.forEach(item => {
						if (item.checked) {
							list.push({
								skuId: item.prdSkuId,
								buyNum: item.curBuyNum
							});
						}
					});
				}
				if (this.digitStandardProduct.length > 0) {
					this.digitStandardProduct.forEach(item => {
						if (item.checked) {
							list.push({
								skuId: item.prdSkuId,
								buyNum: item.curBuyNum
							});
						}
					});
				}
				if (this.jsonStandardProduct.length > 0) {
					this.jsonStandardProduct.forEach(item => {
						if (item.checked) {
							list.push({
								skuId: item.prdSkuId,
								buyNum: item.curBuyNum
							});
						}
					});
				}
				if (list.length === 0) {
					TMessage.warning('您还没选择商品！');
					return;
				}
				const params = {
					goodList: list
				};
				// 先播抛物线动画，待小球砸入购物车并完成冲击反馈后，再发起接口请求
				await this.playCartParabola(event);
				this.$store.dispatch('Cart/addCart', params).then(() => {
					// 接口成功后轻微抖一下，二次强化“已加入购物车”的反馈
					this.shakeCartButton();
					// TMessageBox.confirm('恭喜！商品已加入购物车。', '提示', { confirmButtonText: '去结算' }).then(() => {
					// 	this.$router.push({ path: '/index/Cart' });
					// });
				});
			},

			// 加入购物车抛物线动画：从点击按钮飞入头部购物车，结束时带“砸入”冲击反馈
			playCartParabola(event) {
				return new Promise(resolve => {
					const btn = event && (event.currentTarget || event.target);
					if (!btn) {
						resolve();
						return;
					}
					const startRect = btn.getBoundingClientRect();
					const startX = startRect.left + startRect.width / 2;
					const startY = startRect.top + startRect.height / 2;

					// 终点：优先找 PageHeader 的购物车按钮，找不到回落到右上角
					const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
					let endX, endY;
					if (cartEl) {
						const r = cartEl.getBoundingClientRect();
						endX = r.left + r.width / 2;
						endY = r.top + r.height / 2;
					} else {
						endX = window.innerWidth - 80;
						endY = 40;
					}

					const ball = document.createElement('div');
					ball.innerHTML = '<i class="el-icon-shopping-cart-2"></i>';
					Object.assign(ball.style, {
						position: 'fixed',
						left: startX + 'px',
						top: startY + 'px',
						width: '34px',
						height: '34px',
						lineHeight: '34px',
						textAlign: 'center',
						borderRadius: '50%',
						background: 'linear-gradient(135deg, #f97316, #ef4444)',
						color: '#fff',
						fontSize: '18px',
						zIndex: 9999,
						pointerEvents: 'none',
						boxShadow: '0 6px 16px rgba(239,68,68,0.45)',
						transform: 'translate(-50%, -50%) scale(1)',
						willChange: 'left, top, transform, opacity'
					});
					document.body.appendChild(ball);

					const duration = 450;
					const startTime = performance.now();
					const dx = endX - startX;
					const dy = endY - startY;
					const peak = Math.min(Math.max(Math.abs(dx) * 0.35, 120), 260);

					const animate = now => {
						const t = Math.min((now - startTime) / duration, 1);
						const ease = t * t;
						const x = startX + dx * ease;
						const y = startY + dy * ease - 4 * peak * t * (1 - t);
						const scale = 1 - t * 0.4;
						ball.style.left = x + 'px';
						ball.style.top = y + 'px';
						ball.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
						if (t < 1) {
							requestAnimationFrame(animate);
						} else {
							ball.style.transition = 'transform 140ms ease-out, opacity 160ms ease-out';
							ball.style.transform = 'translate(-50%, -50%) scale(1.6)';
							ball.style.opacity = '0';
							setTimeout(() => ball.remove(), 200);
							if (cartEl && cartEl.animate) {
								cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.82)', offset: 0.35 }, { transform: 'scale(1.18)', offset: 0.7 }, { transform: 'scale(1)' }], {
									duration: 260,
									easing: 'cubic-bezier(.2,.8,.2,1.2)'
								});
							}
							setTimeout(resolve, 180);
						}
					};
					requestAnimationFrame(animate);
				});
			},

			// 购物车按钮抖动反馈：在 addCart 接口成功后触发
			shakeCartButton() {
				const cartEl = document.querySelector('.btn-cart') || document.querySelector('.nav-btnbox .btn-cart') || document.querySelector('[data-cart-target]');
				if (!cartEl || !cartEl.animate) return;
				cartEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
			},

			...mapActions('Settings', ['setLoginShow'])
		},
		components: { BookBox, DialogWatermark }
	};
</script>

<style lang="less" scoped>
	.main-file {
		margin-top: 10px;
	}
	.goods-item {
		margin-bottom: 30px;
		//padding: 10px;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
	}
	.goods-paybox {
		margin-left: 20px;
		font-size: 14px;
		color: #333333;
		ul {
			margin: 10px 0 20px;
			padding: 0;
			list-style-type: none;
		}
		li {
			display: flex;
			align-items: center;
			margin-bottom: 8px;
			i {
				margin-right: 10px;
			}
		}
	}

	// 图书销售协议链接样式
	.agreement-link {
		margin-left: 0;
		margin-top: -3px;
		// color: #1474e2;
		// text-decoration: none;
		// cursor: pointer;
		// transition: text-decoration 0.2s ease;

		&:hover {
			// text-decoration: underline;
		}
	}
	.price-box {
		margin-bottom: 10px;
		color: #888888;
		.price {
			margin-right: 10px;
			font-size: 24px;
			color: #1474e2;
		}
		.gprice {
			margin-right: 10px;
		}
	}
	.view-box {
		color: #888888;
		margin-bottom: 20px;
		span + span {
			margin-left: 25px;
		}
		i {
			margin-right: 5px;
			font-size: 16px;
		}
		em {
			font-style: normal;
		}
	}
	.subact-box {
		display: flex;
		flex-wrap: wrap;
		flex-flow: column;
		gap: 15px;
		// margin-bottom: 15px;
		.subact-btn {
			// margin: 0 20px 15px 0;
			position: relative;
			padding: 12px 10px;
			color: #1474e2;
			background-color: #ffffff;
			border: 2px solid #b3d1ff;
			border-radius: 8px;
			cursor: pointer;
			// flex: 0 0 calc(50% - 7.5px); /* 每排2个按钮，减去间距 */
			box-sizing: border-box;
			transition: all 0.3s ease;
			font-size: 14px;
			margin-left: 0;
			flex: 1;
			i {
				display: block;
				margin-bottom: 6px;
				font-size: 18px;
			}
			.tag-type {
				position: absolute;
				top: 0;
				right: 0;
			}
		}
		.subact-btn:hover {
			border-color: #409eff;
			background-color: #f0f7ff;
			transform: translateY(-1px);
			box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
		}

		.subact-btn-nor {
			color: #888888;
			border: 1px solid #cccccc;
		}
	}
	.act-box {
		margin-bottom: 30px;
		.btn-add {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
			margin-bottom: 20px;
			width: 100%;
			height: 44px;
			border-radius: 30px;
			color: #ffffff;
			font-size: 16px;
			font-weight: 600;
			border: none;
			background: linear-gradient(135deg, #2563eb, #1d4ed8);
			box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
			cursor: pointer;
			transition: all 0.2s ease;
			i {
				font-size: 20px;
			}
			&:hover {
				box-shadow: 0 6px 20px rgba(37, 99, 235, 0.45);
				transform: translateY(-1px);
			}
			&:active {
				transform: translateY(0);
			}
		}
		.btn-buy {
			margin-left: 0;
			background-color: #ec2b2d;
		}
	}

	// ========== 购物商品风格卡片（对齐 Booklist.vue）==========
	.product-list-box {
		margin: 10px 0 20px;
		.product-group {
			margin-bottom: 16px;
			position: relative;
			&:last-child {
				margin-bottom: 0;
			}

			.group-label {
				font-weight: 500;
				font-size: 15px;
				color: #0f172a;
				margin-bottom: 10px;
				display: block;
				position: relative;
				padding-left: 12px;
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 3px;
					height: 14px;
					border-radius: 2px;
					background: #1474e2;
				}
			}
		}
		.product-item {
			display: flex;
			align-items: flex-start;
			gap: 10px;
			padding: 12px 14px;
			border: 1px solid #e2e8f0;
			border-radius: 10px;
			background: linear-gradient(135deg, #fafbff 0%, #f8fafc 100%);
			margin-bottom: 10px;
			cursor: pointer;
			transition: all 0.2s ease;
			&:last-child {
				margin-bottom: 0;
			}
			&:hover {
				border-color: #bfdbfe;
				background: #ffffff;
				box-shadow: 0 3px 10px rgba(37, 99, 235, 0.1);
			}
			&.selected {
				border-color: #1474e2;
				background: #ffffff;
				box-shadow: 0 3px 12px rgba(37, 99, 235, 0.15);
			}
			.item-check {
				flex-shrink: 0;
				margin-top: 2px;
			}
			.product-info {
				flex: 1;
				min-width: 0;
				display: flex;
				flex-direction: column;
				gap: 8px;
			}
			.product-name {
				display: flex;
				align-items: center;
				gap: 6px;
				// flex-wrap: wrap;
				.product-type-tag {
					flex-shrink: 0;
					border-radius: 4px;
					height: 22px;
					line-height: 20px;
					padding: 0 8px;
					font-weight: 600;
				}
				.name-text {
					font-size: 14px;
					font-weight: 600;
					color: #0f172a;
					line-height: 1.4;
				}
			}
			.product-spu {
				font-size: 14px;
				font-weight: 600;
				color: #1e293b;
				max-width: 100%;
				// overflow: hidden;
				// text-overflow: ellipsis;
				// white-space: nowrap;
			}
			.product-price {
				display: flex;
				align-items: baseline;
				gap: 8px;
				flex-wrap: wrap;
				.now-price {
					font-size: 20px;
					font-weight: 800;
					color: #ef4444;
					line-height: 1;
					letter-spacing: -0.3px;
				}
				.before-price {
					font-size: 12px;
					color: #94a3b8;
					text-decoration: line-through;
				}
				.discount-tag {
					border: none;
					padding: 0 6px;
					height: 18px;
					line-height: 18px;
					font-weight: 600;
					border-radius: 4px;
				}
				.vip-price {
					font-size: 12px;
					color: #b45309;
					font-weight: 600;
					background: linear-gradient(135deg, #fef3c7, #fde68a);
					padding: 2px 8px;
					border-radius: 10px;
				}
			}
			.mask-price {
				font-size: 18px;
				font-weight: 700;
				color: #ef4444;
			}
			.quantity-control {
				align-self: flex-start;
			}
			.main-file {
				align-self: flex-start;
				padding: 0;
				color: #2563eb;
				font-size: 12px;
			}
			// 已购状态
			&.purchased {
				// cursor: default;
				border-color: #d1fae5;
				background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
				&:hover {
					border-color: #a7f3d0;
					background: #ffffff;
				}
			}
			.purchased-tag {
				border: none;
				padding: 0 8px;
				height: 20px;
				line-height: 20px;
				font-weight: 600;
				border-radius: 4px;
			}
			.purchased-actions {
				display: flex;
				gap: 10px;
				.btn-download-item,
				.btn-read-item {
					display: flex;
					align-items: center;
					gap: 4px;
					padding: 6px 16px;
					border-radius: 6px;
					font-size: 13px;
					font-weight: 500;
					border: 1px solid;
					cursor: pointer;
					transition: all 0.2s ease;
					i {
						font-size: 14px;
					}
				}
				.btn-download-item {
					color: #2563eb;
					border-color: #bfdbfe;
					background: #eff6ff;
					&:hover {
						background: #2563eb;
						color: #fff;
						border-color: #2563eb;
					}
				}
				.btn-read-item {
					color: #059669;
					border-color: #a7f3d0;
					background: #ecfdf5;
					&:hover {
						background: #059669;
						color: #fff;
						border-color: #059669;
					}
				}
			}
		}
	}
	.msg-box {
		h4 {
			margin: 0;
			font-weight: 400;
			font-size: 18px;
		}
		li {
			color: #686f83;
		}

		p {
			color: #686f83;
			margin: 0;
			line-height: 30px;
		}
	}

	// 只为vip-box中的li添加蓝色小圆点
	.vip-box.msg-box {
		li {
			position: relative;
			padding-left: 14px;
			margin-bottom: 8px;
			line-height: 1.5;
			color: #1f2329;
			display: block;

			// 添加蓝色小圆点
			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				width: 5px;
				height: 5px;
				background-color: rgb(20, 86, 240);
				border-radius: 50%;
			}
		}
	}

	.cart-box {
		ul {
			li {
				display: block;

				.cart-label {
					font-weight: 400;
					font-size: 18px;
					margin-bottom: 12px;
					display: block;
					position: relative;
					padding-left: 14px;
				}
				.cart-label:before {
					position: absolute;
					top: 14px;
					left: 0;
					transform: translate(0, -50%);
					content: '';
					width: 9px;
					height: 18px;
					background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiODUzODkyYi01NmU5LTdhNDgtOGQ0NS03ZGE2ZDZiMGRhMDgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDQ5N0ZBODA5QjlGMTFGMDlCQ0ZFQzYyNDg3RUEwQjIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDQ5N0ZBN0Y5QjlGMTFGMDlCQ0ZFQzYyNDg3RUEwQjIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzE5ZDg0ZDAtYTIwMi00YzQ3LWIwYTMtYzBlZjU1OGZiYjA5IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YTdjZDhiYTYtYmJmZS0wYzQ2LWEyMzctZDkxMTE3ODE2NjhkIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+3zf/VAAAAK5JREFUeNpiFCu+zYAGbIC4HIh9txQpgQWYkCQtgXg3EB8GYm0kDZtZoJyFQBwHU83FxvR9VY4CSIMLEN+HKXJHtk9HhkMLSGlBua9B1rECsRiyIn4uZmTuK5AiSSBmRBYVwKJICt17/JyYiqTRFWEzCUMRP1HWEaNIEFXRa6yKeDmRI4LhBYgngyzCB/QZCxNKiLzFMIkP1ZQ3QPwbFC18MBFgrH8C2YamiAEgwAAAfB0ZgNJp6gAAAABJRU5ErkJggg==)
						no-repeat center center;
					background-size: cover;
				}
			}
		}
		.tag-list {
			flex: 1;

			em {
				font-style: normal;
				color: #606266;
				font-size: 12px;
			}
		}

		.tag-item {
			border: 1px solid #e0e0e0;
			background: #fff;
			cursor: pointer;
			padding: 20px;
			position: relative;
			display: flex;
			align-items: center;
			margin-top: -1px;
			// flex-wrap: wrap;
			gap: 10px;

			.before-price {
				color: #969696;
				text-decoration: line-through;
				font-size: 12px;
			}

			.now-price {
				font-size: 16px;
				color: #ff0f23;
				margin-right: 4px;
			}

			.vip-price {
				color: #1474e2;
				margin-top: 4px;
				display: inline-block;
				margin-right: 12px;
			}

			.stock-num {
				display: inline-block;
				color: #909399;
				margin-top: 4px;
				display: inline-block;
				// margin-left: 12px;
			}

			.sku {
				color: #909399;
				font-size: 12px;
				margin: 8px 0;
				line-height: 18px;
			}

			h6 {
				font-weight: normal;
				font-size: 16px;
				padding: 0;
				margin: 0;
			}

			// 选中状态样式
			&.selected {
				background: #fff;
				border: 1px solid #1474e2;
				z-index: 2;
			}
		}

		.tag-item:hover {
			// 可以添加悬停效果
		}

		.tag-item-paper {
			display: block;

			h6 {
				margin-left: 40px;
			}
		}

		.quantity-control {
			margin-left: auto;
			em {
				margin-right: 12px;
			}
		}
	}
	/deep/ .el-input-number--mini {
		width: 100px;
	}

	//媒体查询-pad
	@media screen and (max-width: 1024px) {
		.goods-paybox {
			margin-left: 10px;
		}
		.view-box span + span {
			margin-left: 10px;
		}
		.subact-box {
			flex-flow: row wrap;
			gap: 10px;
			.subact-btn {
				position: relative;
				margin: 0;
				flex: 0 0 calc(50% - 5px); /* 平板设备上保持两排显示 */
				padding: 10px 8px;
				font-size: 13px;
			}
		}
		// 正版图书购买 产品双列
		.product-list-box .product-group {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 10px;

			.product-item {
				margin-bottom: 0;
			}
		}
	}

	// 手机端响应式
	@media screen and (max-width: 767px) {
		.goods-paybox {
			margin-left: 4px;
		}
		.subact-box {
			flex-flow: row wrap;
			gap: 8px;
			.subact-btn {
				position: relative;
				flex: 0 0 calc(50% - 4px); /* 手机端也保持两排显示 */
				padding: 8px 6px;
				font-size: 12px;
				i {
					font-size: 16px;
					margin-bottom: 4px;
				}
			}
		}
		// 正版图书购买 产品双列
		.product-list-box .product-group {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 8px;

			.product-item {
				margin-bottom: 0;
				padding: 8px 10px;
			}
		}
	}

	.v-hide {
		display: none;
	}
</style>
